export default __webpack_public_path__ + "static/media/Google.79d21c5d.svg";